/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {
  footerCGV: 'footer.cgv',
  footerCredits: 'footer.credits',
  headerAccount: 'header.account',
  headerMenuBack: 'header.menu.back',
  headerStoreLocator: 'header.storeLocator',
};
